import { getShopifyData } from "../config";

const COUNTRY_CODE = process.env.GATSBY_LOCALE_COUNTRY;

export const GetCustomer = async (accessToken) => {
  const query = `query @inContext(country: ${COUNTRY_CODE}) {
    customer(customerAccessToken: "${accessToken}") {
      id
      firstName
      lastName
      displayName
      email
      defaultAddress {
        id
        firstName
        lastName
        address1
        address2
        city
        country
        countryCodeV2
        province
        phone
        zip
      }
      addresses(first: 10) {
        nodes {
          id
          firstName
          lastName
          address1
          address2
          city
          country
          countryCodeV2
          province
          zip
        }
      }
      orders(first: 100, sortKey: PROCESSED_AT, reverse: true) {
        nodes {
          id
          name
          orderNumber
          subtotalPrice {
            amount
            currencyCode
          }
          totalPrice {
            amount
            currencyCode
          }
          totalTax {
            amount
            currencyCode
          }
          totalShippingPrice {
            amount
            currencyCode
          }
          originalTotalPrice {
            amount
          }
          edited
          fulfillmentStatus
          financialStatus
          processedAt
          customerUrl
          billingAddress {
            address1
            address2
            country
            countryCodeV2
            name
            province
            provinceCode
            zip
            countryCodeV2
            city
          }
          shippingAddress {
            address1
            address2
            country
            countryCodeV2
            name
            province
            provinceCode
            zip
            countryCodeV2
            city
          }
          lineItems(first: 100) {
            nodes {
              title
              quantity
              discountedTotalPrice {
                amount
                currencyCode
              }
              originalTotalPrice {
                amount
                currencyCode
              }
              variant {
                id
                title
                sku
                requiresShipping
                product {
                  title
                  handle
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
              }
            }
          }
          
        }
      }
      tags
    }
  }`;
  const response = await getShopifyData(query);

  return response.data.customer;
};
